import React from 'react';
import './global.css';
import JWTAuthProvider from './services/JWTAuthProvider';
import Routes from './services/Routes';
import MsalInstance from './services/sso';
import { MsalProvider } from "@azure/msal-react";

export default function App() {
  return (
    <MsalProvider instance={MsalInstance}>
      <JWTAuthProvider>
        <Routes />
      </JWTAuthProvider>
    </MsalProvider>
  );
}